import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ContactForm from "./ContactForm";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactCTA({ compact = false }) {
    return (
        <section className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden" data-testid="contact-cta-section">
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
            <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-blue-600/10 blur-[120px] pointer-events-none" />
            <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-[120px] pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-5"
                    >
                        <div className="inline-flex items-center gap-2 text-xs font-mono tracking-[0.2em] uppercase text-cyan-400 mb-6">
                            <span className="w-8 h-px bg-cyan-400/60" /> Let's Build
                        </div>
                        <h2 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tighter">
                            Have a project in mind?
                        </h2>
                        <p className="mt-6 text-lg text-slate-400 leading-relaxed">
                            Whether you're planning a new facility, retrofitting a mission-critical system,
                            or exploring decarbonization — our team is ready to help.
                        </p>

                        <div className="mt-10 space-y-5">
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0">
                                    <Mail className="w-4 h-4 text-cyan-400" />
                                </div>
                                <div>
                                    <div className="text-xs font-mono tracking-widest uppercase text-slate-500 mb-1">Email</div>
                                    <div className="text-white">contact@pes-mep.com</div>
                                </div>
                            </div>
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0">
                                    <Phone className="w-4 h-4 text-cyan-400" />
                                </div>
                                <div>
                                    <div className="text-xs font-mono tracking-widest uppercase text-slate-500 mb-1">Phone</div>
                                    <div className="text-white">+1 (713) 555-7740</div>
                                </div>
                            </div>
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center flex-shrink-0">
                                    <MapPin className="w-4 h-4 text-cyan-400" />
                                </div>
                                <div>
                                    <div className="text-xs font-mono tracking-widest uppercase text-slate-500 mb-1">Headquarters</div>
                                    <div className="text-white">3730 Kirby Drive, Greenway / Upper<br />Houston, Texas 77098</div>
                                </div>
                            </div>
                        </div>

                        {compact && (
                            <Link
                                to="/contact"
                                className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-cyan-400 hover:text-cyan-300 transition-colors group"
                            >
                                Go to contact page
                                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
                            </Link>
                        )}
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.15 }}
                        className="lg:col-span-7"
                    >
                        <div className="relative p-6 md:p-10 rounded-2xl bg-slate-900/40 backdrop-blur-xl border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.4)]">
                            <ContactForm />
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
